import React from 'react'
import { useState } from 'react'
import { setAmountPostApi } from '../../../../Api/PanelAdminServices'
import { errorToast, succToast } from '../../../../Utils/Toast/Toast'
import Style from './HandleMoney.module.scss'
const HandleMoney = ({uType,userId,close,onUpdate}) => {
    const[action,setAction]=useState("3")
    const[amount,setAmount]=useState()

    const setAmountToWallet=()=>{
        const info ={
            user_id:userId,
            user_type:uType,
            amount:amount,
            action:action
        }
        setAmountPostApi(info,(res,succ)=>{
            if(res.status===1){
                succToast(res.message)
                onUpdate()
            }else{
                errorToast("مشکلی پیش آمده")
            }
            close()
        })
    }
  return (
    <div className={Style.componentHolder}>
        <select className={Style.actionPart} onChange={(e)=>setAction(e.target.value)}>
            <option value={"3"}>پاداش</option>
            <option value={"2"}>جریمه</option>
        </select>
        <input className={Style.amount} onChange={(e)=>setAmount(e.target.value)} placeholder='مقدار را بصورت عدد و تومان وارد کنید'/>
        <button className={Style.sendBtn} onClick={setAmountToWallet}>ثبت</button>
    </div>
  )
}

export default HandleMoney